import React from 'react'
import config from 'services/config';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import FileExplorer, { computeFullPath } from 'components/common/fileExplorer/fileExplorer';

interface IFileFolderSelectorProps {
    folder?: boolean,
    onSelect: Function,
    filter?: Function,
    value: string
}


interface IFileFolderSelectorState {
    modal: boolean;
    currentSelection?: string;
}

export default class FileFolderSelector extends React.Component<IFileFolderSelectorProps, IFileFolderSelectorState> {
    /**
     *
     */
    constructor(props: IFileFolderSelectorProps) {
        super(props);

        this.state = { modal: false };

    }
    render() {
        return (
            <div>
                <span>{this.props.value || 'Aucun'}</span>{' '}
                <Button onClick={this.toggle.bind(this)}>Selectionner un {this.props.folder ? 'dossier' : 'fichier'}</Button>
                <Modal style={{ width: "70vw", maxWidth: "100vw" }} isOpen={this.state.modal} toggle={this.toggle.bind(this)}>
                    <ModalHeader toggle={this.toggle.bind(this)}>{this.props.folder ? 'dossier' : 'fichier'}</ModalHeader>
                    <ModalBody style={{ height: '300px' }}>
                        <FileExplorer onClick={this.changeSelection.bind(this)} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color={this.state.currentSelection ? "primary" : "secondary"} onClick={this.saveChange.bind(this)} disabled={!this.state.currentSelection}>Sauvegarder</Button>{' '}
                        <Button color="danger" onClick={this.toggle.bind(this)}>Annuler</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    toggle() {
        this.setState({ modal: !this.state.modal, currentSelection: undefined })
    }

    saveChange() {
        this.props.onSelect(this.state.currentSelection);
        this.toggle();
    }

    changeSelection(itemSelected: any) {
        if (this.props.folder ? itemSelected.rowData.type == 'dir' : itemSelected.rowData.type == 'file' && (!this.props.filter || this.props.filter(itemSelected.rowData.name))) {
            this.setState({ currentSelection: `${config.wsUrl != '' ? config.wsUrl : window.location.origin}/${config.rootFolderPath}${computeFullPath(itemSelected.rowData)}` })
        }
        else {
            this.setState({ currentSelection: undefined })

        }
    }
}
